import { GeocoderRepository } from '@/core/repositories/geocoder.repository'

const geocoderRepository = new GeocoderRepository()

import { YandexGeocodeResponseT, TwoGisGeocodeResponseT, YandexGeocodeOptions } from '@/core/types/geocoder.types'

export class GeocoderService {
    async geocode(options: YandexGeocodeOptions): Promise<YandexGeocodeResponseT> {
        const response = await geocoderRepository.geocode(options)
        return response.data
    }

    async yandexGeocode(geocode: string, bbox: number[][] | null): Promise<YandexGeocodeResponseT> {
        const response = await geocoderRepository.yandexGeocode(geocode, bbox)
        return response.data
    }

    async twoGisGeocodeByCoords(coordinates: number[]): Promise<TwoGisGeocodeResponseT> {
        const response = await geocoderRepository.twoGisGeocodeByCoords(coordinates)
        return response.data
    }

    async twoGisGeocodeByAddress(address: string, coordinates: number[][] | null): Promise<TwoGisGeocodeResponseT> {
        const response = await geocoderRepository.twoGisGeocodeByAddress(address, coordinates)
        return response.data
    }
}
